<div class="machine-state-wrapper">
  <div *ngIf="machineState">
    <ion-grid>
      <ion-row>

        <ion-col size="6">

          <ion-row>
            <span fxLayoutAlign="start left" size="small">
              <ion-icon [style.color]="machineState.color" name="{{machineState.icon}}" size="small" class="icon-20 icon-w-value"></ion-icon>
            </span>
            <span class="machine-sub-name">{{getMachineName()}}</span>
          </ion-row>
          <ion-row>
            <span class="value-text">{{machineState.machine.make}} {{machineState.machine.model}}</span>
          </ion-row>

              <ion-row  *ngIf="hasImplement()" class="value-text">
                <ion-icon name="implement" class="icon-20 icon-w-value "></ion-icon> {{getImplementName()}}
              </ion-row>

              <ion-row  *ngIf="!hasImplement()">
                <span class="value-text">
                  <ion-icon name="implement" class="icon-20 icon-w-value"></ion-icon>
                  {{'IMPLEMENT.NO'|translate}}
                </span>
              </ion-row>

              <ion-row *ngIf="hasDriver()" class="value-text">
                <ion-icon name="person" class="icon-20 icon-w-value" color="primary"></ion-icon> {{getDriverName()}}
              </ion-row>

              <ion-row *ngIf="!hasDriver()">
                <span class="value-text">
                  <ion-icon name="person" class="icon-20 icon-w-value"></ion-icon>
                  {{'DRIVER.NO'|translate}}
                </span>
              </ion-row>

            <ion-row *ngIf="hasSpeed()" (click)="onSpeedClick()" class="value-text">
              <ion-icon name="speedometer-outline" size="small" class="icon-20 icon-w-value"></ion-icon>
                {{machineState.currentLocation.sp * 3.6 | number:'0.0-1'}} km/h

              <!-- <ion-progress-bar [value]="getSpeedPercentage()"></ion-progress-bar> -->
            </ion-row>

            <ion-row class="value-text" *ngIf="hasFuelTank()" (click)="onFuelTankClick()">
                <ion-icon name="beaker-outline" size="small" class="icon-20 icon-w-value"></ion-icon>
                {{machineState.currentLocation.ftl | number:'0.0-1'}} %
                <!-- <ion-progress-bar [value]="getFuelTankPercentage()"></ion-progress-bar> -->
            </ion-row>

            <ion-row class="value-text" *ngIf="hasAdBlue()" (click)="onAdBlueClick()">
                <ion-icon name="water-outline" size="small" class="icon-20 icon-w-value"></ion-icon>
                {{machineState.currentLocation.atl | number:'0.0-1'}} %
                <!-- <ion-progress-bar [value]="getAdBluePercentage()"></ion-progress-bar> -->
            </ion-row>

            <ion-row class="value-text" *ngIf="hasGrainTank()" (click)="onGrainTankClick()">
                <ion-icon name="water-outline"  size="small" class="icon-20 icon-w-value"></ion-icon>
                {{machineState.currentLocation.gtl | number:'0.0-1'}} %
                <!-- <ion-progress-bar [value]="getGrainTankPercentage()"></ion-progress-bar> -->
            </ion-row>
        </ion-col>

        <!-- <ion-col size="6"> -->

          <span class="right-column">

            <span class="machine-last-online" *ngIf="machineState.machine.lastPosition">
                <ion-icon class="icon-w-value" name="time-outline"></ion-icon>
                {{ getStatusUpdateTime(machineState.machine) | date: 'dd.MM.yy HH:mm' }}
            </span>

            <span class="machine-tracks value-text">
              <span class="value-text">{{'SHOW_TRACKS'|translate}}</span>
              <span>
                <ion-toggle
                aria-label="Fahsrpuren"
                style="transform: scale(0.5);"
                color="primary"
                [checked]="machineState.pathVisible"
                onchange="onClickToggelOneFahrspuren(machineState.machine.id)"
                (ionChange)="onToggleShowMachineTracks()">
              </ion-toggle>
              </span>
            </span>

            <!-- <span class="machine-tracks" >
              <span class="value-text">Maschinen Fokus</span>
              <ion-toggle aria-label="Focus" style="transform: scale(0.5);" size="small" color="primary" [checked]="false" (ionChange)="centerOnMachine($event, machineState.machine.id)"></ion-toggle>
            </span> -->

            <span class="machine-tracks">
              <span class="value-text">Reload</span>
              <ion-button style="transform: scale(0.5);" size="small" (click)="onClickReloadMachineTracks($event, machineState.machine.id)">
                <ion-icon  name="reload-outline"></ion-icon>
              </ion-button>
            </span>


            <span class="machine-tracks">
              <span class="value-text">Navi</span>
              <span *ngIf="machineState.machine.lastPosition || machineState.currentLocation">
                <ion-button style="transform: scale(0.5);" size="small" (click)="onClickPosition()">
                  <ion-icon name="navigate-outline" class="icon-button inner-center-btn"></ion-icon>
                </ion-button>
              </span>
              <span *ngIf="machineState.machine.lastPosition === null">
                <ion-button style="transform: scale(0.5);" size="small" (click)="onClickPosition()" disabled="disabled">
                  <ion-icon name="navigate-outline" class="icon-button inner-center-btn"></ion-icon>
                </ion-button>
              </span>
            </span>
          </span>
      </ion-row>


      <ion-row *ngIf="machineState.currentAdapterState">
        <!-- ADAPTER STATUS WITH LAST ONLINE AND SO ON-->
        <ion-col [size]="6">
          <div (click)="onAdapterSerialClick()">
            <ion-row>
              <!-- <ion-icon name="hardware-chip-outline" class="icon-w-value" color="primary"></ion-icon> -->
              <ion-label class="value-text-small" color="primary">{{'SERIAL'|translate}}</ion-label>
              <span class="value-text-small">{{machineState.currentAdapterState.an}}</span>
            </ion-row>
          </div>
        </ion-col>
        <ion-col [size]="6">
          <div (click)="onFirmwareClick()">
            <ion-row>
              <!-- <ion-icon name="code-working-outline" class="icon-w-value" color="primary"></ion-icon> -->
              <ion-label class="value-text-small" color="primary">{{'FIRMWARE_VERSION'|translate}}</ion-label>
              <span class="value-text-small">v {{machineState.currentAdapterState.fv}}</span>
            </ion-row>
          </div>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="machineState.currentAdapterState">
        <!-- ADAPTER STATUS WITH LAST ONLINE AND SO ON-->
        <ion-col [size]="3">
          <div (click)="onGPSStatusClick()">
            <ion-row>
              <!-- <ion-icon name="locate-outline" class="icon-w-value" color="primary"></ion-icon> -->
              <ion-label class="value-text-small" color="primary">{{'GPS.STATUS'|translate}}</ion-label>
              <span class="value-text-small">{{machineState.currentAdapterState.gs}}</span>
            </ion-row>
          </div>
        </ion-col>
        <ion-col [size]="3">
          <div (click)="onCANStatusClick()">
            <ion-row>
              <!-- <ion-icon name="git-network-outline" class="icon-w-value" color="primary"></ion-icon> -->
              <ion-label class="value-text-small" color="primary">{{'CAN.STATUS'|translate}}</ion-label>
              <span class="value-text-small">{{machineState.currentAdapterState.cs}}</span>
            </ion-row>
          </div>
        </ion-col>
        <ion-col [size]="5">
          <div (click)="onTCStatusClick()">
            <ion-row>
              <!-- <ion-icon name="newspaper-outline" class="icon-w-value" color="primary"></ion-icon> -->
              <ion-label class="value-text-small" color="primary">{{'TC'|translate}}</ion-label>
              <span class="value-text-small">{{machineState.currentAdapterState.tc}}</span>
            </ion-row>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>
